// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import {ChecklistPage} from '@features/hroc-checklists'
import {useLocation, useParams} from 'react-router'

type PathParameter = {
  plantId?: string
  checklistId?: string
}

export const TaskChecklistPage = () => {
  const {plantId: plantIdFromRoute} = useParams<PathParameter>()
  const {state} = useLocation()
  const plantId = plantIdFromRoute ?? state?.plantId

  if (!plantId) throw new Error('plantId is missing')

  return <ChecklistPage plantId={plantId} />
}
